import React from 'react'
import { Collapse } from 'react-bootstrap'
import { ArrowIcon } from '../Icons/ArrowIcon'
import { colors } from '../../styles/colors'
import styled from 'styled-components'
import OfficeFilter from '../Filter/OfficeFilter'
import CostCenterFilter from '../Filter/CostCenterFilter'
import GroupFilter from '../Filter/GroupFilter'
import { useAssetsState } from '../../stores/AssetsProvider'
import { StyledItemWrapper } from '../TreeList/treeList'
import { useTranslation } from 'react-i18next'

const StyledCollapseWrapper = styled.div`
  margin-bottom: 25px;
 

  ${StyledItemWrapper} {
    background-color: #FFF;
  }

`

const StyledFilterToggle = styled.h2`
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${colors.gray5};
  font-size: 20px;
  margin-bottom: 10px;
  ${ArrowIcon} {
    margin-right: 10px;
  }
`

const OverlayLeftFilter = () => {
  const {
    openOfficeFilter, setOpenOfficeFilter,    
    setOfficeFilter, setOfficeName,
    openCostCenterFilter, setOpenCostCenterFilter,
    setCostCenterFilter, setCostCenterName,
    openGroupFilter, setOpenGroupFilter,
    setGroupFilter, setGroupName
  } = useAssetsState()

  const { t } = useTranslation()
  return (
    <>
      <StyledCollapseWrapper>
        <StyledFilterToggle onClick={() => setOpenOfficeFilter(!openOfficeFilter)} aria-controls="office-collapse"
          aria-expanded={openOfficeFilter}>
          <ArrowIcon variant={openOfficeFilter ? 'down' : 'right'} color={colors.gray5} />{t('orgaUnit')} ({t('orgaUnitShortcut')})
        </StyledFilterToggle>
        <Collapse in={openOfficeFilter}>
          <div id="office-collapse">
            {openOfficeFilter && <OfficeFilter setOfficeFilter = {setOfficeFilter} setOfficeName = {setOfficeName}/>}
          </div>
        </Collapse>
      </StyledCollapseWrapper>

      <StyledCollapseWrapper>
        <StyledFilterToggle onClick={() => setOpenCostCenterFilter(!openCostCenterFilter)}
          aria-controls="costCenter-collapse" aria-expanded={openCostCenterFilter}>
          <ArrowIcon variant={openCostCenterFilter ? 'down' : 'right'} color={colors.gray5} />{t('costcenter')} ({t('costcenterShortcut')})
        </StyledFilterToggle>
        <Collapse in={openCostCenterFilter}>
          <div id="costCenter-collapse">
            {openCostCenterFilter && <CostCenterFilter setCostCenterFilter = {setCostCenterFilter} setCostCenterName = {setCostCenterName}/>}
          </div>
        </Collapse>
      </StyledCollapseWrapper>

      <StyledCollapseWrapper>
        <StyledFilterToggle onClick={() => setOpenGroupFilter(!openGroupFilter)}
          aria-controls="group-collapse" aria-expanded={openGroupFilter}>
          <ArrowIcon variant={openGroupFilter ? 'down' : 'right'} color={colors.gray5} />{t('assetPage:group')} ({t('assetPage:groupShortcut')})
        </StyledFilterToggle>
        <Collapse in={openGroupFilter}>
          <div id="group-collapse">
            {openGroupFilter && <GroupFilter setGroupFilter = {setGroupFilter} setGroupName = {setGroupName}/>}
          </div>
        </Collapse>
      </StyledCollapseWrapper>
    </>
  )
}

export default OverlayLeftFilter
